export default "__VITE_ASSET__CZugnFvN__"